// Tonk's client registry entry (see ../registry.ts and docs/games-contract.md).

import { Layers } from 'lucide-react';
import { CardTableSet } from '../CardTableModel';
import { seatXZ, seatYaw } from '../tableLayout';
import { SEAT_NAMES } from '../../../../supabase/functions/games/tonk.ts';
import { TONK_RULES, TONK_TUTORIAL_TITLE, TONK_TUTORIAL_URL } from './tonkRules';
import { TonkOverlay } from './TonkOverlay';
import { TonkTable3D } from './TonkTable3D';
import { TonkVRPanel } from './TonkVR';
import type { GameClientDef } from '../types';

export const tonkClient: GameClientDef = {
  kind: 'tonk',
  label: 'Tonk',
  blurb: 'Fast rummy-style card game for 2–4 — spread, hit, or drop low.',
  icon: Layers,
  glyph: '♦',
  category: 'table',
  minPlayers: 2,
  maxPlayers: 4,
  bots: true,
  host: 'none',
  joinMidGame: false,
  seatNames: SEAT_NAMES,
  ranking: 'wins',
  chairs: [0, 1, 2, 3].map((i) => { const [x, z] = seatXZ(i); return { x, z, yaw: seatYaw(i) }; }),
  Furniture: CardTableSet,
  Table3D: TonkTable3D,
  Overlay: TonkOverlay,
  VRPanel: TonkVRPanel,
  rules: TONK_RULES,
  tutorial: { url: TONK_TUTORIAL_URL, title: TONK_TUTORIAL_TITLE },
};
